import type { ComplianceBaseline as ComplianceBaselineModel } from '@/adapters/catalogv1.g';

export function extractComplianceBaseline(model: ComplianceBaselineModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.baseline_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    standard: model.standard,
    version: model.version,
    isActive: model.is_active,
    effectiveDate: model.effective_date,
    expirationDate: model.expiration_date,
    requirements: model.requirements,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogComplianceBaseline = ReturnType<
  typeof extractComplianceBaseline
>;
